const values = Object.freeze({
  StructuredInterview: 1,
  DisabilityEvaluationQuestionnaire: 2,
  InterestProfile: 3,
  LearningStyles: 4,
  WorkSampleExecution: 5,
  ValparSystem: 6,
  SAMPR: 7,
  BasicSkillsTest: 8,
  OtherTests: 9,
});

export default values;
